export default __webpack_public_path__ + "static/media/pf-male.icon.5461e996.svg";